/**
 * Deeply merges a given set of objects together.
 *
 * Objects to the right take priority.
 *
 * @param  {...Object} args - The objects to merge.
 *
 * @return {Object} - The merged object.
 */
export default function isEmpty(obj) {
  let empty;

  if (!obj) {
    return true;
  }

  if (!Object.entries)
    Object.entries = function entries(item) {
      const ownProps = Object.keys(item);
      let i = ownProps.length;
      const resArray = new Array(i); // preallocate the Array
      while (i--) resArray[i] = [ownProps[i], item[ownProps[i]]];

      return resArray;
    };

  Object.entries(obj).map(item => {
    if (item) {
      empty = true;
    }
    return item;
  });

  if (empty) {
    return false;
  }

  return true;
}
